<!-- Location Search Input -->
<div class="location-search-wrapper">
  <input #searchInput
         type="text"
         inputmode="search"
         autocomplete="off"
         autocapitalize="words"
         [formControl]="searchControl"
         class="form-control location-search-input new-location-search-input"
         placeholder="Location..."
         (focus)="onInputFocus()"
         (blur)="onInputBlur()"
         (mouseleave)="onInputMouseLeave()"
         (click)="$event.stopPropagation()"
         (touchstart)="onInputTouch($event)">
  <div class="btn-grps btn-group" [ngClass]="{'d-none':!isclearButtonShow}">
    <button class="btn btn-clear-search" (click)="clearSearchbar()">
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
              fill="currentcolor" />
      </svg>
    </button>
  </div>
  <!-- Location Suggestions Dropdown -->
  <div class="location-list new-location-list p-2" *ngIf="searchError" role="status">{{ searchError }}</div>
  <ul #suggestionsList
      class="location-list new-location-list"
      [ngClass]="{'open-up': isDropdownOpenUp}"
      *ngIf="suggestions.length > 0">
    <li *ngFor="let suggestion of suggestions" (click)="onLocationSelect(suggestion)">
      <img src="./assets/images/ic-location-select.svg" alt="Location">
      <p>{{ suggestion.description }}</p>
    </li>
  </ul>
</div> 
